export default "__VITE_ASSET__642668e5__"